$(document).ready(function() {
    initTabClickHandler();
});

function initTabClickHandler() {
    $('.pxm_content.tabs .uk-subnav a[href*="#"]').on('click', function (event) {
        event.preventDefault();
        var tabid = $(this).data('id');

        if (tabid) {
            let params = new URLSearchParams();
            params.append('tab', tabid);
            history.replaceState(null, null, "?"+params.toString());
        }
    });
}
